import { Routes } from '@angular/router';
import { UnauthorizedComponent } from './shared/pages/unauthorized/unauthorized.component';
import { authGuard } from './core/guards/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/authentication/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.routes').then(
        (m) => m.DASHBOARD_ROUTES
      ), // Should contain 'login' route inside
    canActivate: [authGuard],
  },
  {
    path: 'business-unit',
    loadChildren: () =>
      import('./modules/parent-client/parent-client.routes').then(
        (m) => m.PARENT_CLIENT_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'client',
    loadChildren: () =>
      import('./modules/client/client.routes').then((m) => m.CLIENT_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'programs',
    loadChildren: () =>
      import('./modules/programs/program.routes').then((m) => m.PROGRAM_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'location',
    loadChildren: () =>
      import('./modules/location/location.routes').then(
        (m) => m.LOCATION_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'custom-data-filters',
    loadChildren: () =>
      import('./modules/custom-filters/custom-filters.routes').then(
        (m) => m.CUSTOM_FILTERS_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./modules/manage-users/manage-users.routes').then(
        (m) => m.MANAGE_USERS_ROUTES
      ), // Should contain 'login' route inside
    canActivate: [authGuard],
  },
  {
    path: 'roles',
    loadChildren: () =>
      import('./modules/manage-roles/manage-roles.routes').then(
        (m) => m.MANAGE_ROLES_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'dispositions',
    loadChildren: () =>
      import('./modules/disposition/disposition.routes').then(
        (m) => m.DISPOSITION_ROUTES
      ),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/profile/profile.routes').then((m) => m.PROFILE_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./shared/pages/shared.routes').then((m) => m.SHARED_PAGES_ROUTES),
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    title: 'Unauthorized',
    pathMatch: 'full',
  }, // Redirect to unauthorized page
  { path: '', redirectTo: 'login', pathMatch: 'full' }, // Default to login
  { path: '**', redirectTo: 'error/404-not-found' }, // Wildcard must come last
];
